import React, {
  useEffect,
  useState,
} from "react";

import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";

import {
  BUNDLE_OFFERS_API,
} from "../../../../../Utilities/APIs/APIs";
import "./bundleOffer.css";

function ViewBundleOffer({ targetID }) {
  const axiosInstance = useAxiosInstance();

  const [offer, setOffer] =
    useState(null);

  useEffect(() => {
    async function fetchOffer() {
      try {
        const { data } =
          await axiosInstance.get(
            BUNDLE_OFFERS_API +
              targetID
          );

        setOffer(data);
      } catch (error) {
        console.error(
          "Failed to fetch bundle offer:",
          error
        );
      }
    }

    if (targetID) {
      fetchOffer();
    }
  }, [targetID, axiosInstance]);

  if (!offer) {
    return (
      <div className="crud_view_content">
        Loading...
      </div>
    );
  }

  const targetNames = (() => {
    switch (offer.appliesTo) {
      case "products":
        return offer.products?.map(
          (item) =>
            item?.name ||
            item?.squId ||
            item
        );

      case "category":
        return offer.categories?.map(
          (item) =>
            item?.categoryName ||
            item?.name ||
            item
        );

      case "brand":
        return offer.brands?.map(
          (item) =>
            item?.name || item
        );

      case "collection":
        return offer.collections?.map(
          (item) =>
            item?.name || item
        );

      case "productGroup":
        return offer.productGroups;

      case "all":
        return ["All Products"];

      default:
        return [];
    }
  })();

  const appliesLabel = {
    all: "All Products",
    products: "Selected Products",
    category: "Categories",
    brand: "Brands",
    collection: "Collections",
    productGroup: "Product Groups",
  };

return (
  <div className="bundle-view">

    {/* STATUS */}
    <div
      className={`bundle-view-status ${
        !offer.isActive ? "inactive" : ""
      }`}
    >
      {offer.isActive ? "● Active" : "● Inactive"}
    </div>


    {/* OFFER RULE */}
    <div className="bundle-view-section">

      <h1 className="bundle-view-label">
        Offer Rule
      </h1>

      <div className="bundle-view-rule">

        <div className="bundle-view-rule-main">
          Buy {offer.requiredQuantity} → Get{" "}
          {offer.discountType === "percentage"
            ? `${offer.discountValue}% Off`
            : `৳${offer.discountValue} Off`}
        </div>

        <div className="bundle-view-rule-sub">

        {offer.discountType === "amount" ? (
          <>
            Buy {offer.requiredQuantity * 2}
            {" → "}৳{offer.discountValue * 2} off

            <br />

            Buy {offer.requiredQuantity * 3}
            {" → "}৳{offer.discountValue * 3} off
          </>
        ) : (
          <>
            {offer.discountValue}% applies to all
            eligible products once the required
            quantity is reached.
          </>
        )}
      </div>

      </div>

    </div>


    {/* APPLIES TO */}
    <div className="bundle-view-section">

      <h1 className="bundle-view-label">
        Applies To
      </h1>

      <p className="bundle-view-value">
        {appliesLabel[offer.appliesTo] ||
          offer.appliesTo}
      </p>

    </div>


    {/* ELIGIBLE ITEMS */}
    <div className="bundle-view-section">

      <h1 className="bundle-view-label">
        Eligible Items
      </h1>

      <div className="bundle-view-items">

        {targetNames?.length > 0 ? (
          targetNames.map((name, index) => (
            <div
              key={index}
              className="bundle-view-item"
            >
              {String(name)}
            </div>
          ))
        ) : (
          <div className="bundle-view-note">
            No specific items selected.
          </div>
        )}

      </div>

    </div>


    {/* DATE */}
    <div className="bundle-view-section">

      <h1 className="bundle-view-label">
        Start Date
      </h1>

      <p className="bundle-view-value">
        {new Date(
          offer.startDate
        ).toLocaleDateString()}
      </p>

    </div>


    <div className="bundle-view-section">

      <h1 className="bundle-view-label">
        End Date
      </h1>

      <p className="bundle-view-value">
        {new Date(
          offer.endDate
        ).toLocaleDateString()}
      </p>

    </div>


    {/* DISCOUNTED PRODUCTS RULE */}
    <div className="bundle-view-section">

      <h1 className="bundle-view-label">
        Sale Products
      </h1>

      <div className="bundle-view-note">
        Products that already have a discount are
        automatically excluded from this offer.
      </div>

    </div>

  </div>
  );
}

export default ViewBundleOffer;